<template>
  <div>
    <BaseLoading
      v-if="isLoading"
      full-screen
    />
    <BaseInput
      v-model="$v.name.$model"
      :form="$v.name"
      type="text"
      :label="$t('nickname')"
      icon="person"
      @keyup.enter.native="handleRegisterSubmit"
    />

    <BaseInput
      v-model="$v.email.$model"
      class="w-100"
      :form="$v.email"
      type="email"
      icon="email"
      :label="$t('email')"
      @keyup.enter.native="handleRegisterSubmit"
    />

    <b-row>
      <b-col :cols="3">
        <BaseSelect
          v-model="$v.phonePrefix.$model"
          :label="$t('phone')"
          :form="$v.phonePrefix"
          :options="countriesPhones"
        />
      </b-col>
      <b-col
        :cols="9"
        class="d-flex align-items-end"
      >
        <BaseInput
          v-model="$v.phone.$model"
          class="w-100"
          :form="$v.phone"
          type="number"
          @keyup.enter.native="handleRegisterSubmit"
        />
      </b-col>
    </b-row>
    <BaseInput
      v-model="$v.password.$model"
      :form="$v.password"
      type="password"
      :label="$t('password')"
      icon="lock_outline"
      @keyup.enter.native="handleRegisterSubmit"
    />

    <BaseButton
      is-rounded
      class="d-block my-4"
      :is-disabled="$v.$invalid"
      @click="handleRegisterSubmit"
    >
      {{ $t('register') }}
    </BaseButton>

    <b-row>
      <b-col
        :cols="12"
        class="d-flex justify-content-center"
      >
        <SocialiteButtons @click="isLoading=true" />
      </b-col>
      <b-col
        :cols="12"
        class="text-center"
      >
        <BaseLink
          :text="$t('already-have-an-account')"
          :to="{name: 'login'}"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VueCookies from 'vue-cookies'
import { mapActions, mapState } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, email, minLength, maxLength, alphaNum } from 'vuelidate/lib/validators'
import { getCountriesSelectData } from '@/helpers/phones'
import BaseInput from '@/components/Atoms/Form/BaseInput'
import BaseLink from '@/components/Atoms/BaseLink'
import BaseButton from '@/components/Atoms/BaseButton'
import BaseLoading from '@/components/Atoms/BaseLoading'
import BaseSelect from '@/components/Atoms/Form/BaseSelect'
import SocialiteButtons from '@/pages/Auth/Components/SocialiteButtons'
import isLowerCase from '@/helpers/customerValidators/isLowerCase'

export default {
  components: {
    SocialiteButtons,
    BaseSelect,
    BaseLoading,
    BaseButton,
    BaseLink,
    BaseInput,
  },
  mixins: [validationMixin],
  props: {},
  metaInfo() {
    return {
      title: this.$t('page-titles.register'),
      meta: [
        { name: 'description', content: this.$t('page-descriptions.register') },
      ],
    }
  },
  data() {
    return {
      name: null,
      email: null,
      password: null,
      phone: null,
      phonePrefix: this.env === 'tr' ? 90 : 66,
      isLoading: false,
    }
  },
  computed: {
    ...mapState({
      isRegisterProcessing: state => state['auth/register'].isRegisterProcessing,
    }),
    countriesPhones() {
      return getCountriesSelectData()
    },
    env() {
      return process.env.VUE_APP_ENV
    },
  },
  created() {
    if (this.$route.query.email) {
      try {
        this.email = atob(this.$route.query.email)
      } catch (err) { }
    }
  },
  methods: {
    ...mapActions({
      postRegister: 'auth/register/postRegister',
    }),
    handleRegisterSubmit() {
      this.$v.$touch()
      if (!this.$v.$anyError) {
        this.isLoading = true
        this.postRegister({
          name: this.name,
          email: this.email,
          password: this.password,
          invitedBy: VueCookies.get('invitedBy'),
          phone: this.phone ? `+${this.phonePrefix}${this.phone}` : null,
        }).then((res) => {
          this.isLoading = false
          if (res && res.token) {
            if (typeof gtag !== 'undefined') {
              // eslint-disable-next-line no-undef
              gtag('config', 'AW-711377348')
            }
            VueCookies.remove('invitedBy')
            VueCookies.set('registration', true)
            this.$router.push({
              name: 'home',
            })
          }
        })
      }
    },
  },
  validations() {
    return {
      name: {
        required,
        minLength: minLength(3),
        maxLength: this.env === 'cn' ? maxLength(9) : false,
        isLowerCase: this.env === 'cn' ? isLowerCase : false,
        alphaNum: this.env === 'cn' ? alphaNum : false,
      },
      email: {
        required,
        email,
      },
      phonePrefix: {},
      phone: {},
      password: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(12),
      },
    }
  },
}
</script>

<style lang="scss" module>
  .facebookButton {
    display: flex;
    justify-content: center;
    min-width: auto !important;
    padding: 1rem !important;
    border-radius: 50% !important;
    img {
      transform: none !important;
    }
    i {
      margin: 0 !important;
    }
  }
</style>
